import React, { useEffect, useState } from 'react';

const useTimer = (
  verificationTimer,
  reset,
  setverificationTimer
) => {
  const [initialTimer, setInitialTimer] = useState(100);

  useEffect(() => {
    if (verificationTimer) {
      if (initialTimer !== 0) {
        setTimeout(() => {
          setInitialTimer(initialTimer - 1);
        }, 1800); //1800
      } else {
        reset();
        setverificationTimer(false);
        setInitialTimer(100);
      }
    }
  }, [verificationTimer, initialTimer]);

  return initialTimer;
};

export default useTimer;
